import { useEffect, useMemo } from 'react'
import { useMapContext } from '../MapContext'
import { selectAddressContour } from '../../../store/address/address.selectors'
import { useSelector } from 'react-redux'
import { withMapReady } from '../map.utils'
import { reverseShape } from './map.polygon.utils'
import { withEverySelectorTruthy } from '../../utils/react-redux'

const SOURCE_ID_AREA = 'city-shape-area-src'
const SOURCE_ID_LIMIT = 'city-shape-limit-src'
const LAYER_AREA_ID = 'city-shape-area'
const LAYER_LIMIT_ID = 'city-shape-limit'
const CONTOUR_COLOR = '#1A1A1A'

const getPolygonLayer = () => ({
  id: LAYER_AREA_ID,
  type: 'fill',
  source: SOURCE_ID_AREA,
  paint: {
    'fill-opacity': 0.18,
    'fill-color': CONTOUR_COLOR
  }
})

const getLineLayer = () => ({
  id: LAYER_LIMIT_ID,
  type: 'line',
  source: SOURCE_ID_LIMIT,
  paint: {
    'line-opacity': 0.7,
    'line-width': 2,
    'line-color': CONTOUR_COLOR,
    'line-dasharray': [1, 2]
  }
})

const createGeoJSON = geometry => ({
  type: 'geojson',
  data: {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        properties: {},
        geometry
      }
    ]
  }
})

const MapAddressContour = ({ reverse = true }) => {
  const { map } = useMapContext()
  const contour = useSelector(selectAddressContour)
  const shape = useMemo(() => (contour && reverse ? reverseShape(contour) : contour), [reverse, contour])

  const cleanShape = () => {
    if (!map || !map.getLayer(LAYER_AREA_ID)) return
    map.removeLayer(LAYER_AREA_ID)
    map.removeLayer(LAYER_LIMIT_ID)
    map.removeSource(SOURCE_ID_AREA)
    map.removeSource(SOURCE_ID_LIMIT)
  }

  const drawShape = () => {
    if (!shape) return
    map.addSource(SOURCE_ID_AREA, createGeoJSON(shape))
    map.addSource(SOURCE_ID_LIMIT, createGeoJSON(contour))
    map.addLayer(getPolygonLayer())
    map.addLayer(getLineLayer())
  }

  useEffect(() => {
    drawShape()
    return () => cleanShape()
  }, [shape])

  return null
}

export default withMapReady(withEverySelectorTruthy(selectAddressContour)(MapAddressContour))
